import {useEffect,useState} from 'react';
/** Stripe redirects only to a profile; verified invoice drives receipt. */
export function StaffMembershipPaymentReturn({customerId}:{customerId:string}){
  const params=new URLSearchParams(window.location.search);
  const enrollment=params.get('enrollment')??'';
  const location=params.get('location')??'';
  const outcome=params.get('membershipCheckout');
  const valid=Boolean(outcome)&&
    /^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(enrollment)&&
    /^[A-Z0-9_-]{2,64}$/.test(location);
  const [status,setStatus]=useState('');
  useEffect(()=>{
    if(!valid||!customerId)return;
    let active=true;
    const poll=async()=>{
      try{
        const response=await fetch('/api/v1/staff/sales/stripe/test-membership/'+
          encodeURIComponent(enrollment)+'?'+new URLSearchParams({
            customerId,location,
          }),{credentials:'same-origin',cache:'no-store'});
        const body=await response.json() as {ok:boolean;data?:{
          status:string;paidInvoiceCount:number}};
        if(active&&response.ok&&body.ok&&body.data)
          setStatus(body.data.status==='ACTIVE'&&body.data.paidInvoiceCount>=1
            ?'First Stripe TEST invoice verified; membership active and credits issued.'
            :body.data.status==='ENDED'?'Membership ended.':
            'Membership payment is not yet confirmed.');
      }catch{if(active)setStatus('Membership status unavailable.');}
    };
    void poll();const timer=window.setInterval(()=>void poll(),3000);
    return ()=>{active=false;window.clearInterval(timer);};
  },[valid,customerId,enrollment,location]);
  if(!valid)return null;
  return <section className="ecfs-sale-receipt" role="region"
    aria-label="Staff membership Stripe TEST result">
    <h3>Membership Card Payment</h3>
    <p role="status">{status||'Checking Stripe TEST paid invoice…'}</p>
    <small>Enrollment: {enrollment}</small>
  </section>;
}
